import { getDateTimeString, nullUndefined } from "@acri-tools/react-tools/utils"

export const PROJECT_STATUS = [
    'ongoing',
    'completed',
    'planned'
]
export const PROJECT_TYPE = [
    'processing',
    'packaging'
]
export const PROJECT_DATES = [
    'start_date',
    'planned_start_date',
    'completion_date',
    'planned_completion_date'
]
export const PROJECT_NUMBERS = [
    'extraction',
    'collection',
    'consolidation',
    'update',
    'integration',
    'processing',
    'packaging',
    'repatriation'
];

export const PROJECT_PROCESSING_HEADERS = ["collection", "consolidation","integration", "packaging"];

export const PROJECT_PACKAGING_HEADERS = ["update"];

export const get_percentage_color = (percentage?: number | null | undefined) => {
    if (nullUndefined(percentage)) return 'undefined';
    if (percentage !== undefined && percentage !== null && percentage < 100) return 'project-percentage-yellow';
    return 'project-percentage-green';
}

/**
 * For formatting the project data returned **FROM** the API.
 * Especially for the dates that are not formatted in a way that html input datetime-local can interpret (a bit dumb)
 */
export const format_project_data = (data: any) => {
    PROJECT_DATES.forEach((date: string) => {
        if (data[date]) data[date] = getDateTimeString(data[date], true);
    })

    return data;
}


/**
 * For formatting the project data that will be sent **TO** the API.
 */
export const format_project_request_data = (data: any) => {
    Object.keys(data).map((key: string) => {
        if (!data[key]) data[key] = null;
    });

    [
        'collection',
        'consolidation',
        'integration',
        'processing',
        'repatriation',
        'extraction',
        'update',
        'packaging'
    ].map((key: string) => {
        if (data[key] && typeof data[key] === 'string') data[key] = parseInt(data[key])
    })

}